export const environment = {
  production: false,
  title: 'PERUMENTAL',
  baseUrl: 'https://perumental.com',
  seoDescription: 'PERUMENTAL: Tu farmacia digital de confianza. Compra medicamentos como Ritalin, Istaril, Ozempic, Elvenir y más con envío rápido.',
  seoKeywords: 'perumental, farmacia digital, comprar Ritalin, comprar Istaril, Ozempic, Elvenir, Obexol, fentermina, topiramato, metilfenidato, semaglutida',
  catalogFilter: ['perumental', 'ritalin', 'istaril'],
  contactPhone: 'https://wa.me/51976749130',
  favicon: 'favicon.svg',
  heroTitle: 'Tu Salud,<br/><span class="text-gradient">Nuestra Prioridad</span>',
  heroSubtitle: 'Encuentra los medicamentos y productos de salud que necesitas con envío rápido y garantía de calidad.',
  benefits: [
    { icon: 'local_shipping', title: 'Envíos Rápidos', desc: 'Recibe tus productos en tiempo récord.' },
    { icon: 'verified', title: '100% Originales', desc: 'Productos certificados y seguros.' },
    { icon: 'support_agent', title: 'Atención 24/7', desc: 'Asesoría farmacéutica continua.' }
  ]
};
